export default __webpack_public_path__ + "static/media/lionshare.037c295b.png";